import { FETCH_MOVIES, baseUrl, FETCH_ONE_MOVIE } from "./actionType";

export const fetchSuccess = (type, payload) => {
  return {
    type,
    payload,
  };
};

export const fetchMovies = () => {
  return function (dispatch) {
    return fetch(`${baseUrl}/public/movies`)
      .then((res) => {
        if (!res.ok) {
          return res.json().then((msg) => {
            throw msg;
          });
        }
        return res.json();
      })
      .then((data) => {
        dispatch(fetchSuccess(FETCH_MOVIES, data.rows));
      });
  };
};

export const fetchOneMovie = (payload) => {
  return function (dispatch) {
    return fetch(`${baseUrl}/public/movies/${payload}`)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((msg) => {
            throw msg;
          });
        }
        return response.json();
      })
      .then((data) => {
        dispatch(fetchSuccess(FETCH_ONE_MOVIE, data));
      });
  };
};
export const searchMovie = (payload) => {
  return function (dispatch) {
    return fetch(`${baseUrl}/public/movies/search?title=${payload.search}`)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((msg) => {
            throw msg;
          });
        }
        return response.json();
      })
      .then((data) => {
        if (!data.rows.length) {
          throw { message: "Movie not found" };
        } else {
          dispatch(fetchSuccess(FETCH_MOVIES, data.rows));
        }
      });
  };
};
